<template>
  <div>
    <v-server-table
      id="leadsTable"
      ref="leadsTable"
      :name="'leadsTable'"
      :columns="columns"
      :options="tableOptions"
      @row-click="selectLead"
      @limit="this.selectedLeads = {}"
      @filter="onFilterUpdate"
      @loaded="onLoaded"
      @loading="onLoading"
      @pagination="onPagination">

      <template v-if="isLoading" slot="afterBody">
        <div class="overlay-loader"></div>
        <LoadingPlaceholder/>
      </template>

      <span slot="h__selectLead">
        <span class="round">
          <input class="selectLeadCheckbox" type="checkbox" id="checkboxSelectAllLeads" :checked="selectAllLeads" @click="selectAllLeads = !selectAllLeads">
          <label class="selectLeadCheckbox" for="checkboxSelectAllLeads"></label>
        </span>
          <!--<va-checkbox
            :disabled="!getData().length > 0"
            v-if="selectedLeads.length > 0"
            :isCircle="true"
            v-model="selectAllLeads"
          />-->
      </span>

      <span slot="afterFilter" v-if="showQueryResetIcon">
        <i class="fa fa-times reset-filter" @click="resetQueryFilter"></i>
      </span>
      <span slot="afterFilter" class="filters d-none d-lg-flex">
        <div class="d-flex align-items-center">
          <a href="#" @click.prevent="showFilters = !showFilters">
            {{$t('tables.more_filters')}}
            <span  v-if="activeFilters > 0">
              ({{activeFilters}})
            </span>
            &nbsp;
            <i class="fa fa-chevron-down" v-if="!showFilters"></i>
            <i class="fa fa-chevron-up" v-if="showFilters"></i>
          </a>
        </div>
        <div class="d-flex align-items-center ml-3">
          <span class="mr-3" style="font-size: 0.9rem; text-transform:uppercase; color: #29c4a9">
            {{activeTagsSliderTitle}}
          </span>
          <slider class="mb-2" v-model="showTags"></slider>
        </div>
      </span>
      <span slot="beforeTable" class="evollu-form" v-if="showFilters">
        <div class="row">
          <!-- Date Interval Filter -->
          <range-date-picker
            id="selected-time-date-picker"
            class="col-12 col-md-4 datesFilter"
            v-model="filters.dates"
            placeholder=" ---" >

            <div slot="label">
              <label class="form-label" style="margin-top: -3px;">
                {{ $t('statistics.daterange_start') }}
                <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'created_at', 'selectedDateLabel': filters.date == 'created_at'}" @click="setDate('created_at')">{{ $t('statistics.daterange_created_at') }}</span>
                <span class="dateSeparatorLabel">/</span>
                <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'updated_at', 'selectedDateLabel': filters.date == 'updated_at'}" @click="setDate('updated_at')">{{ $t('statistics.daterange_updated_at') }}</span>
                <span class="dateSeparatorLabel">/</span>
                <span class="clickable" :class="{'unselectedDateLabel': filters.date != 'qualified_at', 'selectedDateLabel': filters.date == 'qualified_at'}" @click="setDate('qualified_at')">{{ $t('statistics.daterange_qualified_at') }}</span>
                {{ $t('statistics.daterange_end') }}:
              </label>
            </div>

          </range-date-picker>

          <!-- Statuses Filter -->
          <div class="col-12 col-md-4">
            <label class="form-label">{{ $t('leads.table.status') }}:</label>
            <multiselect
              v-model="filters.statuses"
              :options="statuses"
              track-by="id"
              label="name"
              :custom-label="status => $t(status.name)"
              select-label=""
              selected-label=""
              deselect-label="×"
              placeholder="---"
              :searchable="true"
              :allow-empty="true"
              :multiple="true"
              :limit="3"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
              >
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="filters.statuses.length" @mousedown.prevent.stop="filters.statuses = []"></div>
              </template>
            </multiselect>
          </div>

          <!-- Entities Filter -->
          <div class="col-12 col-md-4">
            <label class="form-label">{{$t('users.inputs.entity')}}:</label>
            <multiselect
              v-model="filters.entities"
              :options="entityOptions"
              track-by="uid"
              :custom-label="formatedEntityLabel"
              label="name"
              select-label=""
              selected-label=""
              deselect-label="×"
              placeholder="---"
              :searchable="true"
              :allow-empty="true"
              :multiple="true"
              :limit="2"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
              :close-on-select="false">
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
              <template slot="tag" slot-scope="{ option, remove }">
                <span class="custom__tag">
                  <span>{{ option.name }}&nbsp;<span v-if="option.entities"> 📂</span></span>
                  <i @click="remove(option)" aria-hidden="true" tabindex="1" class="custom__tag-icon"></i>
                </span>
              </template>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="filters.entities.length" @mousedown.prevent.stop="filters.entities = []"></div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="row">
          <!-- Audiology Providers Filter -->
          <div class="col-12 col-md-4" v-if="isFromEvollu">
            <label class="form-label">{{$t('agenda.screenings.labels.audiology_providers')}}:</label>
            <multiselect
              :options="availableAudProviders"
              v-model="filters.audProviders"
              track-by="id"
              label="name"
              select-label=""
              selected-label=""
              deselect-label="×"
              :custom-label="formatedEntityLabel"
              :placeholder="$t('agenda.screenings.labels.all_entities')"
              :allow-empty="true"
              :multiple="true"
              :searchable="true"
              :limit="10"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')">
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="filters.audProviders.length" @mousedown.prevent.stop="filters.audProviders = []"></div>
              </template>
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
            </multiselect>
          </div>

          <!-- Tags Filter -->
          <div class="col-12 col-md-4">
            <label class="form-label">{{ $t('tags.title') }}:</label>
            <multiselect
              v-model="filters.tags"
              :options="tags"
              track-by="id"
              label="name"
              select-label=""
              selected-label=""
              deselect-label="×"
              placeholder="---"
              :searchable="true"
              :allow-empty="true"
              :multiple="true"
              :limit="3"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
              :close-on-select="false"
              >
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
              <template slot="option" slot-scope="props">
                <span class="option__name">{{ props.option.name }}</span>
                <span v-if="props.option.color">
                  <i class="pl-2 fa fa-tag" :style="{'color': props.option.color}"></i>
                </span>
                <i v-if="props.option.image" class="option__image" :class="props.option.image"></i>
              </template>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="filters.tags.length" @mousedown.prevent.stop="filters.tags = []"></div>
              </template>
            </multiselect>
          </div>

          <!-- Ranking Filter -->
          <div class="col-12 col-md-4">
            <label class="form-label">{{ $t('leads.table.ranking') }}:</label>
            <multiselect
              v-model="filters.ranking"
              :options="rankingOptions"
              track-by="id"
              label="id"
              select-label=""
              selected-label=""
              deselect-label="×"
              placeholder="---"
              :searchable="true"
              :allow-empty="true"
              :multiple="true"
              :limit="3"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
              :close-on-select="false"
            >
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="filters.ranking.length" @mousedown.prevent.stop="filters.ranking = []"></div>
              </template>
            </multiselect>
          </div>

          <!-- Situation Filter -->
          <div class="col-12 col-md-4">
            <label class="form-label">{{ $t('leads.table.situation') }}:</label>
            <multiselect
              v-model="filters.situation"
              :options="situationOptions"
              track-by="id"
              label="id"
              select-label=""
              selected-label=""
              deselect-label="×"
              placeholder="---"
              :searchable="true"
              :allow-empty="true"
              :multiple="true"
              :limit="3"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
              :close-on-select="false"
            >
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="filters.situation.length" @mousedown.prevent.stop="filters.situation = []"></div>
              </template>
            </multiselect>
          </div>

          <!-- Solsticio response filter -->
          <!--<div class="col-12 col-md-4">
            <label class="form-label">{{ $t('leads.table.is_from_solsticio') }}:</label>
            <multiselect
              v-model="filters.solsticio_response"
              :options="solsticioOptions"
              track-by="name"
              label="name"
              select-label=""
              selected-label=""
              deselect-label="×"
              placeholder="---"
              :custom-label="(val) => $t(`leads.table.is_from_solsticio_filter_options.${val.name}`)"
              :searchable="true"
              :allow-empty="true"
              :multiple="true"
              :limit="3"
              :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
              :close-on-select="false"
            >
              <span slot="noResult">{{'patients.noResults'| translate}}</span>
              <template slot="clear" slot-scope="props">
                <div class="multiselect__clear" v-if="filters.solsticio_response.length" @mousedown.prevent.stop="filters.solsticio_response = []"></div>
              </template>
            </multiselect>
          </div>-->
        </div>
      </span>

      <!-- Appointment Intention (A.I.) column header tooltip -->
      <span slot="h__appointment_request">
        <va-popover
          placement="right"
          :message="$t(`leads.table.has_appointment_intention`)"
        >
          <span>{{this.$t('leads.table.ai')}}</span>
        </va-popover>
      </span>
      <span slot="h__has_HearingLoss">
        <va-popover
          placement="right"
          :message="$t(`leads.table.has_hearing_loss`)"
        >
          <span>{{this.$t('leads.table.hl')}}</span>
        </va-popover>
      </span>
      <span slot="h__hearingLossResult">
        <va-popover
          placement="right"
          :message="$t(`leads.table.hearing_test`)"
        >
          <span>{{this.$t('leads.table.ht')}}</span>
        </va-popover>
      </span>
      <span slot="h__noiseTestResult">
        <va-popover
          placement="right"
          :message="$t(`leads.table.noise_test`)"
        >
          <span>{{this.$t('leads.table.nt')}}</span>
        </va-popover>
      </span>

      <!-- Solsticio response column header tooltip -->
      <!--<span slot="h__solsticio_response">
        <va-popover
          placement="right"
          :message="$t(`leads.table.is_from_solsticio`)"
        >
          <span>{{this.$t('leads.table.solsticio')}}</span>
        </va-popover>
      </span>-->

      <span slot="updated_at" class="no-break" slot-scope="props">{{ props.row.updated_at | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="created_at" class="no-break" slot-scope="props">{{ props.row.created_at | localTime('YYYY-MM-DD HH:mm') }}</span>
      <span slot="status" slot-scope="props">
        {{ getStatusByProperty('id', props.row.status) }}
      </span>
      <span slot="serial" slot-scope="props">
        {{ props.row.serial ? props.row.serial : 'N/A' }}
      </span>
      <span slot="aud_provider" slot-scope="props">
        <i v-if="props.row.to_partner === false" class="fa fa-lock"></i>
        {{props.row.aud_provider}}
      </span>
      <span slot="name" slot-scope="props">
        <span v-if="props.row.surname">
          {{ props.row.name + ' ' + props.row.surname | capitalize }}
        </span>
        <span v-if="!props.row.surname">
          {{ props.row.name | capitalize }}&nbsp;
        </span>
        <template v-if="showTags">
          <template v-if="props.row.tags.length">
            <va-popover
              placement="right"
              :message="tag.name"
              v-for="tag in props.row.tags" :key="tag.id"
            >
              <i
                class="fa fa-tag"
                :style="{'color': tag.color}"
                @click.stop="openLeadTagsModal(props.row)"
                @dblclick.stop="openLeadTagsModal(props.row)" />
            </va-popover>
          </template>
          <template v-else>
            <va-popover
              placement="right"
              :message="$t('tags.lead_tag.associate')"
              @click.stop="openLeadTagsModal(props.row)"
            >
              <i
                class="fa fa-tags"
                :style="{'color': '#d3d3d3'}"
                @click.stop="openLeadTagsModal(props.row)"
                @dblclick.stop="openLeadTagsModal(props.row)" />
            </va-popover>
          </template>
        </template>
      </span>
      <span slot="hearingLossResult" slot-scope="props">
        <span v-if="props.row.hearingLossResult">
          <span v-if="props.row.hearingLossResult == 'mild'" :title="$t('leads.table.hl_mild') +' (' + Math.max(props.row.ht.hl_left, props.row.ht.hl_right) + ' dB)'" class="i-evollu-hl-mild"></span>
          <span v-if="props.row.hearingLossResult == 'severe'" :title="$t('leads.table.has_hearing_loss') +' (' + Math.max(props.row.ht.hl_left, props.row.ht.hl_right) + ' dB)'" class="i-evollu-hl-severe"></span>
          <span v-if="props.row.hearingLossResult == 'normal'" :title="$t('leads.table.no_hearing_loss', {dbs: Math.max(props.row.ht.hl_left, props.row.ht.hl_right)})" class="i-evollu-hl-normal"></span>
        </span>
      </span>
      <span slot="noiseTestResult" slot-scope="props">
        <span v-if="props.row.ht_web && props.row.ht_web.length > 0">
          <span v-if="hasHtNoiseLoss(props.row.ht_web[0])" :title="$t('leads.details.ht_web.with_hearing_loss')" class="i-evollu-hl-mild"> </span>
          <span v-else-if="hasHtNoiseNonConclusive(props.row.ht_web[0])" :title="$t('leads.details.ht_web.non_conclusive')">
            <i class="fa fa-question"></i>
          </span>
          <span v-else :title="$t('leads.details.ht_web.without_hearing_loss')" class="i-evollu-hl-normal"></span>
        </span>
        <span v-else>
          N/A
        </span>
      </span>
      <span slot="questionnaire_score" slot-scope="props">
        <span v-if="props.row.answers && props.row.questionnaire_score < 20" :title="$t('leads.table.questionnaire_low_score') + ' (' + props.row.questionnaire_score + ')'" class="i-evollu-questionnaire"></span>
        <span v-if="props.row.questionnaire_score >= 20" :title="$t('leads.table.questionnaire_score') + ' (' + props.row.questionnaire_score + ')'" class="i-evollu-questionnaire-danger"></span>
      </span>
      <span slot="appointment_request" slot-scope="props">
        <va-popover
           v-if="props.row.appointment_request"
           placement="right"
           :message="$t(`leads.table.has_appointment_intention_tooltips.${props.row.appointment_request.toString()}`)"
        >
          <span v-if="props.row.appointment_request">
            <i class="fa fa-check"></i>
          </span>
        </va-popover>
      </span>
      <span slot="has_HearingLoss" slot-scope="props">
        <span :title="$t('leads.table.has_hearing_loss')" v-if="props.row.hasHearingLoss">
          <i class="fa fa-check"></i>
        </span>
        <span
          v-else-if="props.row.ht_web && props.row.ht_web.length > 0 && hasHtNoiseNonConclusive(props.row.ht_web[0])"
          :title="$t('leads.details.ht_web.non_conclusive')"
        >-</span>
      </span>
      <span slot="diagnosed_hl" slot-scope="props">
        <span :title="$t('leads.table.diagnosed_hl')" v-if="props.row.diagnosed_hl">
          <i class="fa fa-check"></i>
        </span>
      </span>
      <span slot="hearing_aid" slot-scope="props">
        <span :title="$t('leads.table.hearing_aid')" v-if="props.row.hearing_aid" class="i-evollu-hearing-aid"></span>
      </span>
      <span slot="qualified_at" slot-scope="props">
        <span :title="$t('leads.table.qualified_lead')" v-if="props.row.qualified_at">
          <i class="fa fa-check"></i>
        </span>
      </span>
      <span slot="contact_request" slot-scope="props">
        <span :title="$t('leads.details.contact_request')" v-if="props.row.contact_request">
          <i class="fa fa-check"></i>
        </span>
      </span>
      <span slot="pendingResolution" slot-scope="props">
        <span :title="checkLeadOutOfSession(props.row)" v-if="checkLeadOutOfSession(props.row) !== null ">
          <i class="i-evollu-warning-black"/>
        </span>
      </span>
      <span slot="selectLead" slot-scope="props" >
        <span class="round">
          <input class="selectLeadCheckbox" type="checkbox" :id="`checkbox${props.row.id}`" :checked="selectedLeads[props.row.id]" @click="handleLeadSelected(props.row)">
          <label class="selectLeadCheckbox" :for="`checkbox${props.row.id}`"></label>
        </span>
        <!--<span class="select is-fullwidth is-small">

          <va-checkbox
            v-if="selectedLeads.length > 0"
            :isCircle="true"
            v-model="selectedLeads[props.index-1]"
          />
        </span>-->
      </span>

      <span slot="situation" slot-scope="props">
         <va-popover
           v-if="props.row.situation"
           placement="right"
           :message="$t(`leads.table.situation_tooltips.${props.row.situation.toString()}`)"
         >
           {{props.row.situation}}
         </va-popover>
      </span>

      <span slot="ranking" slot-scope="props">

         <va-popover
           v-if="props.row.ranking"
           placement="right"
           :message="$t(`leads.table.ranking_tooltips.${props.row.ranking.toString()}`)"
         >
           {{props.row.ranking}}
         </va-popover>
      </span>

      <span slot="to_partner" slot-scope="props">
        <span :title="$t('leads.table.to_partner')" v-if="props.row.to_partner === null">
          -
        </span>
        <span :title="$t('leads.table.to_partner')" v-if="props.row.to_partner === true">
          <i class="fa fa-check"></i>
        </span>
        <span :title="$t('leads.table.to_partner')" v-if="props.row.to_partner === false">
          <i class="fa fa-times"></i>
        </span>
      </span>

    </v-server-table>

    <TagLeadModal
      v-if="showTagLeadModal"
      v-bind="tagLeadProps"
      @tagsWereAssociatedToLead="tagsWereAssociatedToLead"
      @closeTagLeadModal="closeTagLeadModal" />

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TagLeadModal from './TagLeadModal'
import Multiselect from 'vue-multiselect'
import Slider from '@/components/common/Slider'
import { TagsService } from '@/api/LeadsService'
import IsFromEvollu from '@/mixins/IsFromEvolluMixin'
import TableQueryMixin from '@/mixins/TableQueryMixin'
import RangeDatePicker from '@/components/common/RangeDatePicker'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import { FILTERS_LEADS_SHOW_TAGS, TABLE_LEADS } from '@/local-storage/LocalStorageKeys'
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter'
import ClustersAndEntitiesMixin from '@/mixins/ClustersAndEntitiesMixin'
import {
  isValidPhoneNumber, ParseError,
  parsePhoneNumber, parsePhoneNumberWithError
} from 'libphonenumber-js'
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation";
import LoadingPlaceholder from "@/components/common/LoadingPlaceholder";

export default {
  components: {
    LoadingPlaceholder,
    LoadingAnimation,
    Slider,
    Multiselect,
    TagLeadModal,
    RangeDatePicker
  },
  mixins: [
    IsFromEvollu,
    TableQueryMixin,
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  props: {
    entities: {
      type: Array,
      required: true
    },
    querySearch: {
      type: String,
      required: false
    },
  },
  data () {
    return {
      rankingOptions: [
        {id: 1},
        {id: 3},
        {id: 5},
        {id: 7},
        {id: 9}
      ],
      situationOptions: [
        {id: 1},
        {id: 2},
        {id: 3},
        {id: 4},
        {id: 5}
      ],
      solsticioOptions: [
        {name: "0"},
        {name: "1"},
        {name: "none"} // key for fetching null values on BE
      ],
      filters: {
        querySearch: '',
        entities: [],
        audProviders: [],
        statuses: [],
        tags: [],
        ranking: [],
        situation: [],
        solsticio_response: [],
        date: 'created_at',
        dates: {
          start: null,
          end: null
        }
      },
      isLoading: false,
      numberVisibleLeads: 0,
      showFilters: false,
      showTags: false,
      queryUrl: `${this.$store.state.evollead_server}pursues`,
      tableOptions: {selectable:{
          mode: 'multiple',
          programmatic: false
        },
        saveState: true,
        storage: 'local',
        filterable: ['created_at', 'updated_at', 'name', 'entity', 'status'],
        sortable: ['created_at', 'updated_at', 'name', 'city', 'questionnaire_score', 'appointment_request', 'has_HearingLoss', 'diagnosed_hl', 'hearing_aid', 'qualified_at', 'contact_request', 'ranking', 'situation', 'to_partner'],
        customFilters: ['status', 'entity', 'datestart', 'dateend', 'date', 'tags', 'audprovider', 'ranking', 'situation'],
        headings: {
          created_at: this.$t('leads.table.created_at'),
          updated_at: this.$t('leads.table.updated_at'),
          name: this.$t('leads.table.name'),
          city: this.$t('leads.details.city'),
          status: this.$t('leads.table.status'),
          serial: this.$t('leads.table.serial'),
          entity: this.$t('leads.table.entity'),
          aud_provider: this.$t('leads.table.aud_provider'),
          appointment_request: this.$t('leads.table.ai'),
          has_HearingLoss: this.$t('leads.table.hl'),
          qualified_at: this.$t('leads.table.eql'),
          hearingLossResult: this.$t('leads.table.ht'),
          noiseTestResult: this.$t('leads.table.noise_test'),
          questionnaire_score: this.$t('leads.table.quest'),
          diagnosed_hl: this.$t('leads.table.dhl'),
          hearing_aid: this.$t('leads.table.ha'),
          contact_request: this.$t('leads.contact_request'),
          ref_id: this.$t('leads.table.ref_id'),
          pendingResolution: 'P.R.',
          ranking: this.$t('leads.table.ranking'),
          situation: this.$t('leads.table.situation'),
          solsticio_response: this.$t('leads.table.solsticio'),
          to_partner: this.$t('leads.table.to_partner')
        },
        columnsDisplay: {
          created_at: 'desktop',
          updated_at: 'min_mobile',
          name: 'min_mobile',
          city: 'desktop',
          status: 'min_tablet',
          entity: 'min_tablet',
          appointment_request: 'desktop',
          has_HearingLoss: 'desktop',
          hearingLossResult: 'desktop',
          noiseTestResult: 'desktop',
          questionnaire_score: 'desktop',
          diagnosed_hl: 'desktop',
          hearing_aid: 'desktop',
          qualified_at: 'min_tablet',
          pendingResolution: 'desktop',
          selectLead: 'desktop',
          to_partner: 'desktop'
        },
        columnsClasses: {
          created_at: 'created_at',
          updated_at: 'updated_at',
          name: 'name',
          city: 'city',
          status: 'status',
          entity: 'entity',
          appointment_request: 'appointment_request',
          has_HearingLoss: 'has_HearingLoss',
          hearingLossResult: 'hearingLossResult',
          noiseTestResult: 'hearingLossResult',
          questionnaire_score: 'questionnaire_score',
          diagnosed_hl: 'diagnosed_hl',
          hearing_aid: 'hearing_aid',
          qualified_at: 'qualified_at',
          pendingResolution: 'pendingResolution',
          selectLead: 'selectLead',
          solsticio_response: 'solsticio_response',
          to_partner: 'has_HearingLoss'
        },
        rowClassCallback: row => {
          if(this.checkLeadOutOfSession(row)) {
            return 'pr-row'
          }

        },
        rowAttributesCallback: row => {
          if(this.checkLeadOutOfSession(row)) {
            //return {"style": "background: #FFF9E7; background"};
          }

        }
      },
      tags: [],
      tagLeadProps: {},
      showTagLeadModal: false,
      selectedLeads: {},
      selectAllLeads: false,
    }
  },
  created () {
    this.loadTags()
  },
  mounted () {
    let state = LocalStorageHelper.get(TABLE_LEADS)
    /*if(state && state.perPage) {
      for (let i = 0; i < state.perPage; i++) {
        this.selectedLeads[i] = false
      }
    } else {
      for (let i = 0; i < 10; i++) {
        this.selectedLeads[i] = false
      }
    }*/
    this.showOrHideColumns(state)
  },
  methods: {
    hasHtNoiseLoss: function(ht) {
      var hasHl = false

      if(ht.headphones_type && ht.headphones_type === 'mono' && ht.hl_left) {
        hasHl = true
      } else if(ht.hl_left || ht.hl_right) {
        hasHl = true
      }

      return hasHl
    },
    hasHtNoiseNonConclusive: function(ht) {
      return ht.calculated_result_left === 'non_conclusive' || ht.calculated_result_right === 'non_conclusive'
    },
    handleLeadSelected: function(lead) {
      this.selectedLeads[lead.id] = !this.selectedLeads[lead.id];
    },
    getSelectedLeads: function() {
      const keys = Object.keys(this.selectedLeads);
      const selectedLeadIds = keys.filter(key => this.selectedLeads[key] === true);
      const selectedLeads = this.getData().filter(lead => selectedLeadIds.some(id => parseInt(id) === lead.id));
      return selectedLeads;
    },
    getCustomQueries: function() {
      return this.$refs.leadsTable.customQueries;
    },
    getData: function() {
      return this.$refs.leadsTable.data;
    },
    getStatusByProperty: function(property, value) {
      let status = this.statuses.find(status => status[property] === value);
      return status ? this.$t(status.name) : null;
    },
    showOrHideColumns: function(state) {
      if (state) {
        let displayedColumns = state.userColumnsDisplay || this.columnsDisplayedByDefault;
        this.columns
          .filter(column => !displayedColumns.includes(column))
          .forEach(column => column !== 'selectLead' ? this.$refs.leadsTable.toggleColumn(column) : null);
      }
      let dropdownList = this.$el.getElementsByClassName('VueTables__columns-dropdown')[0].lastElementChild;
      dropdownList.removeChild(dropdownList.childNodes[0]);
    },
    tagsWereAssociatedToLead: function({ lead, tags }) {
      lead.tags = tags;
      this.showToast(this.$t('tags.update_success'), this.$store.state.successToastOptions);
      this.closeTagLeadModal();
    },
    closeTagLeadModal: function () {
      this.showTagLeadModal = false
      this.tagLeadProps = {}
    },
    openLeadTagsModal: function (lead) {
      this.tagLeadProps = {
        selectedLead: lead,
        selectedTags: lead.tags || [],
        tags: this.tags
      }
      this.showTagLeadModal = true
    },
    reload: function () {
      this.$refs.leadsTable.refresh()
    },
    onPagination: function() {
      this.selectAllLeads = false
      this.selectedLeads = {}
    },
    onLoading: function (state) {
      this.isLoading = true
    },
    onLoaded: function (state) {
      this.$emit('loaded', {
        count: state.count,
        page: this.$refs.leadsTable.page,
        loading: this.$refs.leadsTable.loading,
        limit: this.$refs.leadsTable.limit,
        totalPages: this.$refs.leadsTable.totalPages
      })
      this.selectAllLeads = false
      this.selectedLeads = {}
      const leads = this.getData()
      for (const lead of leads) {
        this.selectedLeads[lead.id] = false
      }
      this.isLoading = false
    },
    setDate: function (date) {
      this.filters.date = date
    },
    loadLocalStorage: function () {
      let state = LocalStorageHelper.get(TABLE_LEADS)
      if (state) {
        if (Object.values(state.customQueries).some(object => object !== '')) {
          this.showFilters = true

          if (Array.isArray(state.selectedEntityUids) && state.selectedEntityUids) {
            this.filters.entities = this.reloadSelectedClustersAndEntities(this.entityOptions, state.selectedEntityUids)
          }

          if (state.customQueries.status !== '') {
            this.loadStatusFilters(state.customQueries.status.split(',').map(status => parseInt(status)))
          }

          if (state.customQueries.date !== '') {
            this.filters.date = state.customQueries.date
          }

          if (state.customQueries.datestart !== '' && state.customQueries.dateend !== '') {
            this.filters.dates.start = state.customQueries.datestart
            this.filters.dates.end = state.customQueries.dateend
          }

          if (state.customQueries.audprovider !== '') {
            this.loadAudProviderFilter(state.customQueries.audprovider.split(',').map(provider => parseInt(provider)))
          }

          if (state.customQueries.tags !== '') {
            this.loadTagsFilter(state.customQueries.tags.split(',').map(tag => parseInt(tag)))
          }
          if(state.customQueries.solsticio_response !== '') {
            this.filters.solsticio_response = this.solsticioOptions.filter(elem => state.customQueries.solsticio_response.split(",").includes(elem.name));
          }
        }
      }
    },
    loadAudProviderFilter (providers) {
      this.filters.audProviders = this.availableAudProviders.filter(provider => providers.some(providerId => providerId === provider.id))
    },
    loadTagsFilter: function (tags) {
      this.filters.tags = tags.map(tag => this.tags.find(_tag => _tag.id === tag)).filter(tag => tag)
    },
    loadStatusFilters (statuses) {
      this.filters.statuses = statuses.map(status => this.statuses.find(_status => _status.id === status)).filter(status => status)
    },
    loadTags: function () {
      TagsService.query()
        .then(tags => {
          this.tags = tags
        })
        .catch(errors => console.log('errors', errors))
        .finally(() => this.loadLocalStorage())
    },
    selectLead: function ({ event, row }) {
      if(event.srcElement.className ==="selectLeadCheckbox") {
        event.stopPropagation()
      } else {
        this.$emit('lead-selected', { lead: row })
      }
    },
    getTableReference: function () {
      return this.$refs.leadsTable
    },
    isGbOrUkCountry(country) {
      return country.toLowerCase() === "uk" || country.toLowerCase() === "gb" || country.toLowerCase() === "gg"
    },
    checkLeadOutOfSession: function (lead) {
      if(lead.out_of_session) {
        return this.$t('leads.lead_out_of_session')
      }

      const leadEntity = this.entities.filter(ent => ent.id === lead.entity_id)[0]

      if(lead.phone && leadEntity.country) {
        //console.log(parsePhoneNumber(row.row.phone, leadEntity.country))
        if(isValidPhoneNumber(lead.phone, leadEntity.country) === true) {
          try {
            const phoneNr = parsePhoneNumberWithError(lead.phone, this.isGbOrUkCountry(leadEntity.country) ? "GB" : leadEntity.country)
            if (phoneNr.country.toLowerCase() === leadEntity.country.toLowerCase() || (this.isGbOrUkCountry(phoneNr.country) && this.isGbOrUkCountry(leadEntity.country))) {
              return null
            } else {
              return this.$t('leads.invalid_phone')
            }
          } catch (error) {
            console.log(error)
            /*if (error instanceof ParseError) {
              console.log(error.message)
            } else {
              throw error
            }*/
            return this.$t('leads.invalid_phone')
          }
        } else {
          return this.$t('leads.invalid_phone')
        }
      }
      return null
    },
    getNumberEntitiesWithPermissions: function (entitiesIds) {
      return entitiesIds.filter(entityId => {
        return this.entities.some(entity => entity.id === entityId)
      }).length
    },
  },
  computed: {
    ...mapGetters({
      clusters: 'clusters',
      availableAudProviders: 'availableAudProviders',
      statuses: 'leads/statuses'
    }),
    entityOptions: function () {
      return this.createClustersAndEntitiesList(this.clusters, this.entities)
    },
    activeFilters: function () {
      let numFilters = 0
      Object.keys(this.filters).forEach(filter => {
        if (Array.isArray(this.filters[filter])) {
          numFilters += this.filters[filter].length
        }
        if (filter === 'dates' && this.filters.dates.start && this.filters.dates.end) {
          numFilters = numFilters + 1
        }
      })
      return numFilters
    },
    activeTagsSliderTitle: function () {
      return this.showTags ? this.$t('tags.lead_tag.hide') : this.$t('tags.lead_tag.display')
    },
    columns: function () {
      if (this.$auth.user().entity_id === 1) {
        return ['selectLead', 'created_at', 'updated_at', 'name', 'city', 'entity', 'aud_provider', 'status', 'serial', 'appointment_request', 'has_HearingLoss', 'hearingLossResult', 'noiseTestResult', 'questionnaire_score', 'diagnosed_hl', 'hearing_aid', 'qualified_at', 'contact_request', 'ref_id', 'pendingResolution', 'ranking', 'situation', 'to_partner']
      } else {
        return ['selectLead', 'created_at', 'updated_at', 'name', 'city', 'entity', 'status', 'appointment_request', 'has_HearingLoss', 'hearingLossResult', 'noiseTestResult', 'questionnaire_score', 'diagnosed_hl', 'hearing_aid', 'qualified_at', 'contact_request', 'to_partner']
      }
    },
    columnsDisplayedByDefault: function () {
      if (this.$auth.user().entity_id === 1) {
        return ['selectLead', 'created_at', 'name', 'city', 'entity', 'aud_provider', 'status', 'appointment_request', 'has_HearingLoss', 'hearingLossResult', 'noiseTestResult', 'questionnaire_score', 'qualified_at', 'pendingResolution', 'ranking', 'situation', 'to_partner']
      } else {
        return ['selectLead', 'created_at', 'name', 'city', 'entity', 'status', 'appointment_request', 'has_HearingLoss', 'hearingLossResult', 'noiseTestResult', 'questionnaire_score', 'qualified_at', 'to_partner']
      }
    }
  },
  watch: {
    selectAllLeads: function(value) {
      const keys = Object.keys(this.selectedLeads)
      for (const key of keys) {
        this.selectedLeads[key] = value
      }
    },
    showTagsInTable: function (value) {
      LocalStorageHelper.set(FILTERS_LEADS_SHOW_TAGS, value)
    },
    showTags: function (value) {
      if (!value && this.filters.tags.length) {
        this.filters.tags = []
      }
    },
    querySearch: {
      handler: function (value) {
        this.filters.querySearch = value || ''
      },
      immediate: true
    },
    activeFilters: function (value) {
      this.$emit('filters-updated', {
        count: value,
        filters: this.filters
      })
    },
    'filters.querySearch': function (value) {
      this.$refs.leadsTable.setFilter(value)
      this.$emit('filters-updated', { filters: this.filters, count: this.activeFilterCount })
    },
    'filters.dates': function (value) {
      this.$refs.leadsTable.customQueries.datestart = value.start || ''
      this.emitTableFilter('vue-tables.leadsTable.filter::dateend', value.end || '')
    },
    'filters.date': function (date) {
      if (date === '') {
        this.$refs.leadsTable.customQueries.date = date
      } else {
        this.emitTableFilter('vue-tables.leadsTable.filter::date', date)
      }
    },
    'filters.entities': function (options) {
      const selectedOptions = this.getSelectedOptionsIdsAndUids(options)
      this.emitTableFilter('vue-tables.leadsTable.filter::entity', Array.from(selectedOptions.ids).join(','))
      this.$nextTick(() => {
        let state = LocalStorageHelper.get(TABLE_LEADS)
        state.selectedEntityUids = Array.from(selectedOptions.uids)
        LocalStorageHelper.set(TABLE_LEADS, state)
      })
    },
    'filters.tags': function (tags) {
      if (tags.length && !this.showTags) {
        this.showTags = true
      } else if (!tags.length && this.showTags) {
        this.showTags = false
      }
      this.emitTableFilter('vue-tables.leadsTable.filter::tags', tags.map(tag => tag.id).join(','))
    },
    'filters.statuses': function (statuses) {
      this.emitTableFilter('vue-tables.leadsTable.filter::status', statuses.map(status => status.id).join(','))
    },
    'filters.audProviders': function (audProviders) {
      this.emitTableFilter('vue-tables.leadsTable.filter::audprovider', audProviders.map(provider => provider.id).join(','))
    },
    'filters.ranking': function(rankings) {
      this.emitTableFilter('vue-tables.leadsTable.filter::ranking', rankings.map(ranking => ranking.id).join(','))
    },
    'filters.situation': function(situations) {
      this.emitTableFilter('vue-tables.leadsTable.filter::situation', situations.map(situation => situation.id).join(','))
    },
    'filters.solsticio_response': function(solsticio_response) {
      this.emitTableFilter('vue-tables.leadsTable.filter::solsticio_response', solsticio_response.map(sr => sr.name).join(','))
    },
  }
}
</script>
<style scoped>

table {
  width: 100%;
  position: relative;
}
.overlay-loader {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  filter: blur(5px);
  z-index: 2;
}

.loading-placeholder {
  position: absolute;
  left: 65%;
  right: 50%;
  bottom: 60%;
  top: 40%;
  z-index: 3;
}

.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 1.375rem;
  left: 0;
  position: absolute;
  top: 0;
  width: 1.375rem;
}

.round label:after {
  border: 2px solid #fff;
  border-top: none;
  border-right: none;
  content: "";
  height: 6px;
  left: 5px;
  opacity: 0;
  position: absolute;
  top: 6px;
  transform: rotate(-45deg);
  width: 12px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #29c4a9;
  border-color: #29c4a9;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}

</style>
<style lang="scss">
.table-hover tbody tr:hover {
  background: rgba(41, 196, 170, 0.5) !important;
}
  .pr-row {
    background: #FFF9E7 !important;
  }

  .pr-row:hover {
    background: rgba(41, 196, 170, 0.5) !important;
  }

  .unselectedDateLabel {
    font-size: 0.6rem !important;
    color: #ada7a1 !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    text-decoration: line-through !important;
  }

  .dateSeparatorLabel {
    font-size: 0.6rem !important;
    color: #ada7a1 !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
  }

  .selectedDateLabel {
    font-size: 0.6rem !important;
    color: #29c4a9 !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
  }
  .i-evollu-warning-black {
    padding-left: 10px;
    padding-right: 10px;
  }

  .va-checkbox .va-icon {
    color: white;
  }


</style>
